export function initBackofficeTable(claim, inputValue, nextpage) {
    if (inputValue == null || inputValue == undefined) {
        inputValue = "";
    }
    if (nextpage == null || nextpage == "null" || nextpage == undefined) {
        nextpage = "";
    }


    let dt = $("#userBackofficeTable").DataTable({
        destroy: true,
        "pagingType": "simple",
        pagelength: 20,
        lengthMenu: [[20, -1], [20, "Todos"]],
        ajax: {
            cache: false,
            url: `/api/backoffice/search?claim=${claim}&value=${inputValue}&nextpage=${nextpage}`,
            dataSrc: "users",
            complete: function (data) {
                nextpage = encodeURIComponent(data.responseJSON.nextPage);

            }
        },
        "info": false,
        "searching": false,
        "bLengthChange": false,
        dom: '<"top"i>rt<"bottom"flp><"clear">',
        columns: [
            {
                data: {
                    id: 'id',
                    username: 'username'
                }
            },
            { data: 'firstName' },
            { data: 'lastName' },
            { data: 'company' },
            { data: 'email' },
            {
                data: {
                    id: 'id',
                    accountLocked: 'accountLocked',
                    accountDisabled: 'accountDisabled',
                    username: 'username'
                }
            },
        ],
        order: [[1, 'asc']],
        "columnDefs": [
            {
                className: "p-2 align-middle",
                "render": function (data) {
                    return `<a href="/backoffice/edit/${data.id}" class="dp-link dp-link-primary">
                                <div class="dp-content-desktop-link-content-start">
                                    <span class="dp-link-text-medium">${data.username}</span>
                                </div>
                            </a>`
                },
                "targets": 0
            },
            {
                className: "p-2 align-middle",
                "targets": 1
            },
            {
                className: "p-2 align-middle",
                "targets": 2
            },
            {
                className: "p-2 align-middle",
                "targets": 3
            },
            {
                className: "p-2 align-middle",
                "targets": 4
            },

            {
                className: "p-2 align-middle",
                "render": function (data) {
                    let locked = data.accountLocked ? "lock" : "lock_open";
                    let disabled = data.accountDisabled ? "person_off" : "person";
                    return `<a href="/backoffice/delete/${data.id}" title="Delete"><span class='material-symbols-outlined text-primary'>delete</span></a>
                            <a style="cursor:pointer;"
                               data-bs-value="${!data.accountDisabled}"
                               data-bs-id="${data.id}"
                               data-bs-username="${data.username}"
                               data-bs-controller="Backoffice"
                               data-bs-action="Disable"
                               data-bs-method="post"
                               data-bs-title-button="${data.accountDisabled ? 'Enable' : 'Disable'}"
                               data-bs-toggle="modal"
                               title="${data.accountDisabled ? 'Enable' : 'Disable'}"
                               data-bs-target="#confirmModal">
                            <span class='material-symbols-outlined text-primary'>${disabled}</span></a>
                                ${data.accountLocked ? `<a style="cursor:pointer;"
                                       data-bs-value="${!data.accountLocked}"
                                       data-bs-id="${data.id}"
                                       data-bs-username="${data.username}"
                                       data-bs-controller="Backoffice"
                                       data-bs-action="lock"
                                       data-bs-method="post"
                                       data-bs-title-button="${data.accountLocked ? 'Unlock' : 'Lock'}"
                                       data-bs-toggle="modal"
                                       title="${data.accountLocked ? 'Unlock' : 'Lock'}"
                                       data-bs-target="#confirmModal">
                                    <span class='material-symbols-outlined text-primary'>${locked}</span></a>` : ``}
                            `;
                },
                "sortable": false,
                "targets": 5
            }
        ]
    });

    $('#userBackofficeTable').off('init.dt');

    $('#userBackofficeTable').on('init.dt', function() {

 

        $('#userBackofficeTable_next').removeClass('disabled')
        $('#userBackofficeTable_next a').removeAttr('href');
        $('#userBackofficeTable_next a').css("cursor", "pointer");
        $('#userBackofficeTable_next a').onclick = null;
        $("#userBackofficeTable_next a").click(function () { initBackofficeTable(claim, inputValue, nextpage) });
        if (nextpage == "null" || nextpage == null) {
            $('#userBackofficeTable_next a').hide();
        }


        $('#userBackofficeTable_previous').removeClass('disabled')
        $('#userBackofficeTable_previous').hide()
        $('#userBackofficeTable_previous a').removeAttr('href');
        $('#userBackofficeTable_previous a').css("cursor", "pointer");
        $('#userBackofficeTable_previous a').onclick = null;
        $("#userBackofficeTable_previous a").click(function () { initBackofficeTable(claim, inputValue, "",) });
        
    })
}

export async function ExportFileFromDotnetStreamReference(contentStreamReference, fileName) {
    const arrayBuffer = await contentStreamReference.arrayBuffer();
    const blob = new Blob([arrayBuffer]);
    const url = URL.createObjectURL(blob);
    const anchorElement = document.createElement('a');
    anchorElement.href = url;
    anchorElement.download = fileName ?? '';
    anchorElement.click();
    anchorElement.remove();
    URL.revokeObjectURL(url);
}

export function initConfirmModal() {
    var confirmModal = document.getElementById('confirmModal')
    confirmModal.addEventListener('show.bs.modal', function (event) {
        // Button that triggered the modal
        let button = event.relatedTarget
        let value = button.getAttribute('data-bs-value');
        let id = button.getAttribute('data-bs-id');
        let username = button.getAttribute('data-bs-username');
        let controller = button.getAttribute('data-bs-controller');
        let action = button.getAttribute('data-bs-action');
        let actionButton = button.getAttribute('data-bs-title-button')
        let method = button.getAttribute('data-bs-method');
        let routeId = button.getAttribute('data-bs-route-id');
        let form = $('#confirmModal form');
        let submitButton = $('#confirmModal form button[type="submit"]');
        let modalTitle = confirmModal.querySelector('.modal-title');

        var actionValue = '/api/' + controller + '/' + action;
        if (routeId != null) {
            actionValue += '/' + routeId;
        }
        form.attr('action', actionValue);
        form.attr('method', method);

        submitButton.attr('title', actionButton);
        submitButton.text(actionButton);

        $('#confirmModal .modal-body input[name="value"]').val(value);
        $('#confirmModal .modal-body input[name="username"]').val(username);
        $('#confirmModal .modal-body input[name="id"]').val(id);

        modalTitle.textContent = 'Confirm ' + actionButton;
        $('.modal-body p').html('Are you sure want to ' + actionButton + ' <strong>' + username + "</strong>?");
    });
}